import Pill from 'components/Pill';
import { AVAILABILITY_FILTER_OPTIONS } from 'data/subOptions/availabilitySubOptions';
import routeToSearchURL from 'modules/homescreen/helpers/routeToSearchURL';
import React from 'react';
import deepClone from 'utils/deepClone';

const CSS = require('./FilterTags.module.scss');

const filterOutFilters = [
  'adults',
  'children',
  'date.to',
  'date.from',
  'languages.items[]',
];

function removeFilter(category, subcategory, activeFilter) {
  const newSelectedCategories = deepClone(activeFilter);

  let selectedCategory = newSelectedCategories.find(
    (selCategory) => selCategory.uid === category.uid,
  );
  if (!selectedCategory) {
    selectedCategory = deepClone(
      activeFilter.find((filCategory) => filCategory.uid === category.uid),
    );
    selectedCategory.subOptions = [];
    selectedCategory.value = undefined;
    newSelectedCategories.push(selectedCategory);
  }

  if (category.subOptions.length > 0 && subcategory) {
    const subcategoryIndex = selectedCategory.subOptions.some(
      (selSub) => selSub.id === subcategory.id,
    );
    if (subcategoryIndex) {
      selectedCategory.subOptions = selectedCategory.subOptions.filter(
        (selSub) => selSub.id !== subcategory.id,
      );
    } else {
      selectedCategory.subOptions.push(subcategory);
    }
  } else {
    const isAlreadySelected = selectedCategory.value === category.value;
    selectedCategory.value = isAlreadySelected ? '' : category.value;
  }

  routeToSearchURL({ filtersToAdd: newSelectedCategories, replace: true });
}

function FilterTags({ activeFilters }) {
  return (
    <div className={CSS.FilterTags}>
      {activeFilters
        .filter((filter) => !filterOutFilters.includes(filter.uid))
        .map((filter) => {
          if (
            filter.subOptions.length === 0 &&
            filter.uid !== 'other.availability.items[]'
          ) {
            const onRemove = () => removeFilter(filter, null, activeFilters);
            return (
              <Pill key={filter.uid} name={filter.name} onRemove={onRemove} />
            );
          }
          const subOptions =
            filter.uid === 'other.availability.items[]'
              ? filter.subOptions.filter(
                  (subOption) =>
                    subOption.value === AVAILABILITY_FILTER_OPTIONS.NOW,
                )
              : filter.subOptions;
          return subOptions.map((subOption) => {
            const onRemove = () =>
              removeFilter(filter, subOption, activeFilters);
            return (
              <Pill
                key={subOption.id}
                name={subOption.name}
                onRemove={onRemove}
              />
            );
          });
        })}
    </div>
  );
}

export default FilterTags;
